<script setup lang="ts">
defineProps<{
  src: string | null;
  poster?: string | null;
  aspect?: string;
  /** 'video' (default) renders a <video>; 'image' renders an <img>. */
  kind?: 'video' | 'image';
}>();
</script>

<template>
  <div class="prev" :style="{ aspectRatio: aspect ?? '9 / 16' }">
    <img
      v-if="src && kind === 'image'"
      :src="src"
      alt=""
    />
    <video
      v-else-if="src"
      :src="src"
      :poster="poster ?? undefined"
      autoplay
      muted
      loop
      playsinline
    />
    <div v-else class="ph" />
  </div>
</template>

<style scoped>
.prev {
  border-radius: var(--r-lg);
  overflow: hidden;
  background: var(--bg-overlay);
}
.prev video,
.prev img { width: 100%; height: 100%; object-fit: cover; }
.ph { width: 100%; height: 100%; }
</style>
